var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M6.7,7.6H4.1c-0.3,0-0.6,0.3-0.6,0.6v28.5c0,0.4,0.3,0.6,0.6,0.7h2.6c0.3-0.1,0.6-0.3,0.6-0.7v-6.9h30.4 v6.9c0,0.4,0.3,0.6,0.6,0.7h2.6c0.3-0.1,0.6-0.3,0.6-0.7v-12c0-0.3-0.3-0.6-0.6-0.6h-0.7V19c0-0.3-0.3-0.6-0.6-0.6H25v-1.3 c0-0.3-0.3-0.6-0.6-0.6h-5.7c-0.3,0-0.6,0.3-0.6,0.6v1.3h-1.6c0.2-0.3,0.3-0.7,0.3-1.1v-0.4c0-1.3-1-2.3-2.3-2.3c0,0-0.1,0-0.1,0 h-4.1C9,14.5,8,15.5,7.9,16.8c0,0,0,0.1,0,0.1v0.4c0,0.4,0.1,0.8,0.3,1.1H7.3V8.2C7.3,7.9,7,7.6,6.7,7.6z M38.9,19.6V24H25v-4.4 H38.9z M23.7,17.7V24h-4.4v-6.3H23.7z M9.2,16.9c0-0.6,0.5-1.1,1.1-1.1h4.1c0.6,0,1.1,0.5,1.1,1.1v0.3c0,0.6-0.5,1.1-1.1,1.1h-4.1 c-0.6,0-1.1-0.5-1.1-1.1V16.9z M10.3,19.6h7.8v4.5H7.3v-4.5H10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.3,18.3h4.1c0.6,0,1.1-0.5,1.1-1.1v-0.3c0-0.6-0.5-1.1-1.1-1.1h-4.1c-0.6,0-1.1,0.5-1.1,1.1v0.3 C9.2,17.8,9.7,18.3,10.3,18.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 19.6,
    fill: "#C9C9C9",
    width: 13.9,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.3,
    y: 17.7,
    fill: "#C9C9C9",
    width: 4.4,
    height: 6.3
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4AB8DC",
    points: "7.3,24.1 18.1,24.1 18.1,19.6 10.3,19.6 7.3,19.6  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.d637f11376ecf350242732eb4a9e57ec.svg";
export { ForwardRef as ReactComponent };